<div class="header-page"  id="header" [ngClass]="{'scrolled': isScrolled}">
    <div class="container-logo" (click)="irinicio()">
        <img src="assets/logo/logo-malek-2.svg" height="80px" alt="" >
    </div>
    <div class="container-carrito">
        <span class="badge-cart" *ngIf="totalItemsCart>0">{{totalItemsCart}}</span>
        <button class="button-cuadrado" (click)="onToggleSidenav()"><mat-icon svgIcon="cart"></mat-icon></button>
    </div>
</div>
